// The Queue conversation list's customer-identity display (App.jsx's own
// render call) — extracted so it's unit-testable with node --test (no React
// harness available), same convention toAddressAutoSelect.js/
// suggestionActionInputs.js already use.
//
// Precedence, in order:
//   1. A genuine display name (a real person's name, or an eBay buyer
//      username — never a raw address standing in for one).
//   2. c.customerEmail (repositories/conversations.js's listConversations())
//      — the customer email identified at generation time: the matched TRQ
//      order's own emailAddress, or (m365_email only) the raw From: header
//      when no order was found.
//   3. Whatever displayName IS available, even if it's the raw-address
//      fallback from (1) — still better than 'Unknown' when customerEmail
//      never resolved either (e.g. an older row from before that column
//      existed).
//   4. 'eBay' for a FROM_EBAY system event (no buyer participant at all).
//   5. 'Unknown'.
//
// FROM_EBAY system events (cancels/returns) have no buyer participant — step
// 4 covers those specifically. (Buyer-name extraction from the event text /
// reference_id is a separate follow-up.)
export function partyName(c) {
  // A task contact (Tasks Phase 1, 2026-10-13) has no customer participant:
  // it reads "Task T1001".
  if (c?.channel === 'task') return c.metadata?.taskId != null ? `Task T${c.metadata.taskId}` : 'Task'
  const displayName = c.customer?.displayName
  // channels/m365/mapper.js falls back to the raw sender address itself as
  // displayName when no real name is available anywhere (a contact form's
  // own name field, or the message's From-header display name) — in that
  // case displayName === externalUserId exactly, since both are just the
  // same raw address. That fallback must not outrank the properly-resolved
  // customerEmail below (this was the actual bug: it "only worked" for
  // automated_return_notice, the one messageKind where mapper.js leaves the
  // whole customer participant null, so there was no displayName at all to
  // false-positive on). Scoped to m365_email specifically — eBay's own
  // displayName is always the buyer's real eBay username, a genuine
  // identity, never a raw-address stand-in, so it keeps winning outright.
  const isRawAddressFallback = c.channel === 'm365_email' && Boolean(displayName) && displayName === c.customer?.externalUserId
  if (displayName && !isRawAddressFallback) return displayName
  if (c.customerEmail) return c.customerEmail
  if (displayName) return displayName
  if (c.metadata?.ebayConversationType === 'FROM_EBAY') return 'eBay'
  return 'Unknown'
}
